import React from 'react';
import MetricsContextPropsType from './ContextPropTypes';
import config from './config';

export default React.createContext<MetricsContextPropsType>(config);
